import { createAction, props } from '@ngrx/store';
export const deleteSystemAlert = createAction('[Alerts App] Delete System Alert', props());
export const createSystemAlert = createAction('[Alerts App] Create System Alert', props());
